import { render, staticRenderFns } from "./article_modal.vue?vue&type=template&id=05916ffa&scoped=true&"
import script from "./article_modal.vue?vue&type=script&lang=js&"
export * from "./article_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05916ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05916ffa')) {
      api.createRecord('05916ffa', component.options)
    } else {
      api.reload('05916ffa', component.options)
    }
    module.hot.accept("./article_modal.vue?vue&type=template&id=05916ffa&scoped=true&", function () {
      api.rerender('05916ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/item/article_modal.vue"
export default component.exports